import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import AdsEvaluation from "../../components/ads-evaluation/ads-evaluations";
import AdsOverview from "../../components/ads-evaluation/overview";
import SuggestionGallery from "../../components/ads-evaluation/suggestion-gallery";
import FunnelPerformanceOverview from "../../components/ads-evaluation/funnel-performance-overview";
// import AdsAnalytics from "../../components/ads-evaluation/analytics";

const AdsEvaluationPage = () => {
  return (
    <>
      <Routes>
        <Route element={<AdsEvaluation />}>
          <Route index path="overview" element={<AdsOverview />} />
          <Route path="suggestion-gallery" element={<SuggestionGallery />} />
          <Route
            path="funnel-overview"
            element={<FunnelPerformanceOverview />}
          />
          <Route path="*" element={<Navigate to="overview" />} />
          {/* <Route path="insights" element={<AdsAnalytics />} /> */}
        </Route>
      </Routes>
      <Outlet />
    </>
  );
};
export default AdsEvaluationPage;
